<template lang="pug">
  b-container(fluid)
    b-row
      b-col.page-wrap(cols="12")
        div(slot="header").d-flex.justify-content-between.page-header
        b-container(fluid)
          b-row
            b-col(cols="12")
              b-card.mb-3.w-100(no-body)
                div.profile-header(slot="header") {{$t('profile')}}
                b-list-group(flush)
                  b-list-group-item
                    b-row
                      b-col.essential(cols="5" md="5" lg="2") *
                        div.d-inline.ml-1 {{$t('ID')}}
                      b-col(cols="7" md="7" lg="10") {{user.mgrid}}
                  // 비밀번호
                  b-list-group-item
                    b-row
                      b-col.essential.d-flex.align-items-center(cols="5" md="5" lg="2") *
                        div.d-inline.ml-1 {{$t('PW')}}
                      b-col(cols="7" md="7" lg="10")
                        div(v-if="!passwd.modify")
                          b-btn(size="sm", @click="pwInputChange(true)" variant="secondary" ) {{$t('change')}}
                        div(v-else-if="this.user.member_type_id === 1 || this.user.member_type_id === 2 || this.user.member_type_id === 6" )
                          b-form-group(
                            label-size="sm",
                            :description="$t(validatePasswordLevels[this.password_level])",
                            :label="$t('enter_new_password')")
                            b-form-input(type="password", autocomplete="new-password", :state="memberPwState(this.password_level)", v-model.trim="passwd.value", size="sm")
                          b-form-group(
                            label-size="sm",
                            :label="$t('PW_confirm')")
                            b-form-input(type="password", autocomplete="new-password", :state="pwcState", v-model.trim="passwd.confirm", size="sm")
                          div.d-flex.mb-1
                            b-btn(
                              size="sm",
                              variant="success",
                              :disabled="!memberPwState(this.password_level) || !pwcState",
                              @click="setPassword()",
                              class="mr-2") {{$t('do_change')}}
                            b-btn(size="sm", @click="pwInputChange(false)") {{$t('cancel')}}
                        div(v-else)
                          b-form-group(
                            label-size="sm",
                            :description="$t('password_requirement')",
                            :label="$t('enter_new_password')")
                            b-form-input(type="password", autocomplete="new-password", :state="pwState", v-model.trim="passwd.value", size="sm")
                          b-form-group(
                            label-size="sm",
                            :label="$t('PW_confirm')")
                            b-form-input(type="password", autocomplete="new-password", :state="pwcState", v-model.trim="passwd.confirm", size="sm")
                          div.d-flex
                            b-btn(
                              size="sm",
                              variant="success",
                              :disabled="!pwState || !pwcState",
                              @click="setPassword()",
                              class="mr-2") {{$t('do_change')}}
                            b-btn(size="sm", @click="pwInputChange(false)") {{$t('cancel')}}
                  b-list-group-item(v-if="AppState.isCorporate")
                    b-row
                      b-col.essential(cols="5" md="5" lg="2") *
                        div.d-inline.ml-1 {{$t('advenced_auth')}}
                        i.fas.fa-question-circle.fa-lg(@click="HelpOTP")
                      b-col(cols="7" md="7" lg="10").d-flex.align-items-center
                        switches.lmm-switch(
                          v-model="useOtp",
                          theme="bootstrap",
                          :color="useOtp ? 'warning' : 'default'",
                          @input="toggleChanged('useOtp', 'flag_use_otp')")
                        div.ml-2
                          small(style="color:#a0a0a0") * {{$t('OTP_desc')}}
                          a.ml-2(@click="resetOTP", style="color: #0073BB; cursor: pointer;") {{$t('reset_n', {v: 'OTP'})}}
                            icon.ml-1(name="edit")
                        //b-btn.otp-reset-button(size="sm", @click="resetOTP") {{$t('reset_n', {v: 'OTP'})}}

                  b-list-group-item(v-if="!AppState.perm.isAdmin && AppState.perm.isApprover && user.use_approval")
                    b-row
                      b-col(cols="5" md="5" lg="2") {{$t('approver')}}
                      b-col(cols="7" md="7" lg="10") {{this.approver_id}} ({{this.approver_name}})
                  b-list-group-item
                    b-row
                      b-col.essential(cols="5" md="5" lg="2") *
                        div.d-inline.ml-1 {{$t('Email')}}
                      b-col(cols="7" md="7" lg="10")
                        editable(
                          name="email"
                          :value="user.email",
                          :wait="wait.email",
                          @changed="valueChange")
                  b-list-group-item
                    b-row
                      b-col.essential(cols="5" md="5" lg="2") *
                        div.d-inline.ml-1 {{$t('name')}}
                      b-col(cols="7" md="7" lg="10")
                        editable(
                          name="name"
                          :value="user.name",
                          :wait="wait.name",
                          @changed="valueChange")
                  b-list-group-item
                    b-row
                      b-col.essential(cols="5" md="5" lg="2") *
                        div.d-inline.ml-1 {{$t('phone')}}
                      b-col(cols="7" md="7" lg="10")
                        editable(
                          name="phone"
                          :value="user.phone",
                          :wait="wait.phone",
                          @changed="valueChange")
                  b-list-group-item
                    b-row
                      b-col(cols="5" md="5" lg="2")
                        div {{$t('department')}}
                      b-col(cols="7" md="7" lg="10")
                        editable(
                          name="department"
                          :value="user.department",
                          :wait="wait.department",
                          @changed="valueChange")
                  b-list-group-item
                    b-row
                      b-col(cols="5" md="5" lg="2")
                        div {{$t('cowork_position')}}
                      b-col(cols="7" md="7" lg="10")
                        editable(
                          name="position"
                          :value="user.position",
                          :wait="wait.position",
                          @changed="valueChange")
            b-col(cols="12")
              div.mb-3
                b-card.w-100(no-body)
                  div(slot="header") {{$t('setting')}}
                  b-list-group(flush)
                    b-list-group-item
                      b-row
                        b-col(cols="5" md="5" lg="2")
                          div {{$t('timezone')}}
                        b-col(cols="7" md="7" lg="10")
                          tz-select(@changed="timezoneChanged")
                    b-list-group-item
                      b-row
                        b-col(cols="5" md="5" lg="2")
                          div {{$t('date_format')}}
                        b-col(cols="7" md="7" lg="10")
                          b-form-select(
                            size="sm",
                            v-model="dateFormat.value",
                            :options="dateFormat.options",
                            @change="dateFmtChange")
</template>

<script>
import _ from 'lodash'
import Switches from 'vue-switches'
import {TimezoneConverter} from '@/api/util'
import {FileUploadAPI, setDateFmt, user} from '@/api/access'
import Editable from '../mixins/editable'
import TzSelect from '../mixins/tzselect'
import {getUserData} from '../../api/access'
import {CompanyFunctionAPI} from '@/api'

export default {
  name: 'profile-component',
  components: { Editable, TzSelect, Switches },
  computed: {
    pwState () {
      return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$/.test(this.passwd.value)
    },
    pwcState () {
      return this.passwd.value === this.passwd.confirm
    }
  },
  methods: {
    memberPwState (passwordLevel) {
      if (passwordLevel === 0) return /^.{4,12}$/.test(this.passwd.value);
      if (passwordLevel === 1) return /^(?=.*?[a-zA-Z])(?=.*?[0-9]).{6,12}$/.test(this.passwd.value)
      if (passwordLevel === 2) return /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$/.test(this.passwd.value)
      if (passwordLevel === 3) return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$/.test(this.passwd.value)
    },
    resetOTP () {
      let params = {
        context: {path: 'reset_n', args: {v: 'OTP'}},
        withoutInput: true,
        submit: {
          size: 'sm',
          color: 'danger',
          text: 'submit'
        }
      }
      this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
        if (key === 'submit') {
          user('flag_create_qrcode', false)
            .then(() => {
              this.AppState.$emit('show-message-dialog', { context: {path: 'otp_reset_complete'} })
            })
            .catch(err => {
              // console.error(err)
              this.AppState.$emit('show-message-dialog', { context: {path: 'otp_reset_failed'} })
            })
        }
      })
    },
    HelpOTP () {
      this.AppState.$emit('show-helpOTP-dialog', { context: {path: 'help_otp'} })
    },
    dragOverHandler (ev) {
      this.dragover = true
    },
    dragLeaveHandler (ev) {
      this.dragover = false
    },
    dropHandler (ev) {
      this.dragover = false
      var file = null
      this.$log.info('[FILE DROPPED]')
      if (ev.dataTransfer.items) {
        if (ev.dataTransfer.items[0].kind === 'file') {
          file = ev.dataTransfer.items[0].getAsFile()
        }
      } else file = ev.dataTransfer.files[0]
      // Pass event to removeDragData for cleanup
      // removeDragData(ev)
      this.uploadLogo(file)
    },
    pwInputChange (state) {
      this.passwd.modify = state
      this.passwd.value = ''
      this.passwd.confirm = ''
    },
    setPassword () {
      user('pw', this.passwd.value)
        .then(resp => {
          this.AppState.$emit('show-message-dialog', { context: {path: 'password_modified'} })
          this.pwInputChange(false)
        })
        .catch(resp => {
          this.AppState.$emit('show-message-dialog', { context: {path: 'password_modified_failed'} })
          this.pwInputChange(false)
        })
    },
    dateFmtChange (value) {
      user('date_fmt_id', value)
        .then(resp => {
          let r = setDateFmt(value)
          this.AppState.Info.dateFmt = r.value
        })
    },
    uploadLogo (data) {
      var file = null
      if (data.target) file = data.target.files[0]
      else file = data
      const fd = new FormData()
      fd.append('file', file)

      FileUploadAPI.post('', fd)
        .then(resp => {
          this.AppState.$emit('logo-changed')
          this.timestamp = new Date().getTime()
        })
    },
    toggleChanged (dataKey, dbKey) {
      if (!this.pageMounted) return
      user(dbKey, this[dataKey])
    },
    valueChange (key, value) {
      this.$log.debug(`[CHANGED KEY: ${key}, VALUE: ${value}]`)
      this.wait[key] = true
      user(key, value)
        .then(resp => {
          this.wait[key] = false
        })
    },
    timezoneChanged (tz) {
      this.$log.debug(`[TIMEZONE NAME: ${tz.name}, OFFSET: ${tz.offset}]`)
      let id = TimezoneConverter('offset', tz.offset)
      if (id) {
        let tzv = _.assign({}, id, tz)
        this.AppState.Info.timezone = tzv
        this.AppState.$emit('timezone-changed')
      }
    },
    async getData () {
      const resp=await CompanyFunctionAPI.get()

      this.password_level = resp.data.objects[0].password_level
    }
  },
  created () {
    getUserData(null, (err) => {
      if (err) this.$log.error('[REFRESH USER DATA FAILED]')
      this.user = user()
      this.dateFormat.value = this.user.date_fmt_id
      this.useOtp = this.user.flag_use_otp
      this.approver_name = this.user.approver_name
      this.approver_id = this.user.approver_id
      this.useRefresh = this.user.flag_refresh
      this.useLiveviewRefresh = this.user.flag_img_refresh
      this.timestamp = new Date().getTime()
    })
  },
  mounted () {
    this.pageMounted = true
    this.getData()
  },
  data () {
    return {
      password_level: null,
      timestamp: 0,
      dragover: false,
      pageMounted: false,
      user: {},
      wait: {
        email: false,
        name: false,
        phone: false,
        tel: false,
        department: false,
        position: false,
        refresh_interval: false
      },
      useOtp: false,
      useRefresh: false,
      useLiveviewRefresh: false,
      approver_id: '',
      approver_name: '',
      dateFormat: {
        value: null,
        options: [
          {value: 0, text: 'YY/MM/DD'},
          {value: 1, text: 'MM/DD/YY'},
          {value: 2, text: 'DD/MM/YY'}
        ]
      },
      validatePasswordLevels: [
        this.$t('password_level0'),
        this.$t('password_level1'),
        this.$t('password_level2'),
        this.$t('password_level3'),
      ],
      passwd: {
        modify: false,
        value: '',
        confirm: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.lmm-content-body-padded {
  padding: 0;
}

.row, .col, .container-fluid, .col-12 {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

.title {
  font-size: 1.3rem;
  font-weight: bold;
}

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
  > .card-header {
    border-bottom: 1px solid #D2D2D2;
    font-size: 1.2rem;
    font-weight: 500;
  }
}

.list-group-item {
  padding-top: 0.45rem;
  padding-bottom: 0.45rem;
  border: 1px solid #D2D2D2;
}

.col-2 {
  color: #000000;
  > div {
    margin-left: 0.63rem;
  }
}

.essential {
  color: #EC7211;
  align-items: center;
  > div {
    color: #000000;
  }
}

.fas{
  color: #C5C5C5;
  margin-left: 6px;
  cursor: pointer;
}

.dropdown {
  width: 15%;
}
.custom-select {
  width: 15%;
}

.btn-success {
  color: #FFFFFF !important;
  font-weight: 400;
  height: 1.3rem;
  display: flex;
  align-items: center;
}

.btn-secondary {
  color: black !important;
  font-weight: 400;
  height: 1.3rem;
  display: flex;
  align-items: center;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

</style>